const DEMO_STORAGE_KEY = 'misslemon_demo';

let urlChecked = false;

/**
 * If URL has ?demo=1, persist to sessionStorage and remove param from URL (once per load).
 */
function syncDemoFromUrl() {
  if (typeof window === 'undefined' || urlChecked) return;
  urlChecked = true;
  const params = new URLSearchParams(window.location.search);
  if (params.get('demo') === '1') {
    sessionStorage.setItem(DEMO_STORAGE_KEY, '1');
    const url = new URL(window.location.href);
    url.searchParams.delete('demo');
    const newPath = url.pathname + (url.search ? url.search : '');
    window.history.replaceState({}, '', newPath);
  }
}

/**
 * True when app is in demo mode: VITE_APP_ENV=demo, or sessionStorage flag, or ?demo=1 (synced once).
 */
export function isDemoMode() {
  if (typeof window === 'undefined') return false;
  syncDemoFromUrl();
  return (
    import.meta.env.VITE_APP_ENV === 'demo' ||
    sessionStorage.getItem(DEMO_STORAGE_KEY) === '1'
  );
}

export function clearDemoMode() {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(DEMO_STORAGE_KEY);
}
